<div class="space-y-4">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center py-12">
    <ng-container *ngIf="loadingTemplate; else defaultLoading">
      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
    </ng-container>
    <ng-template #defaultLoading>
      <div class="flex justify-center">
        <svg class="animate-spin h-8 w-8 text-primary-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </ng-template>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && data.length === 0" class="text-center py-12 text-gray-500 dark:text-gray-400">
    <ng-container *ngIf="emptyTemplate; else defaultEmpty">
      <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
    </ng-container>
    <ng-template #defaultEmpty>
      {{ emptyMessage }}
    </ng-template>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!isLoading && data.length > 0" [class]="'grid ' + gridClass + ' gap-4'">
    <ng-container *ngIf="itemTemplate; else defaultItem">
      <ng-container *ngFor="let item of data; let i = index; trackBy: trackByItem">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: i }"></ng-container>
      </ng-container>
    </ng-container>
    <ng-template #defaultItem>
      <div
        *ngFor="let item of data; trackBy: trackByItem"
        class="bg-white dark:bg-gray-800 rounded-lg shadow-soft p-4 hover:shadow-md transition-all duration-200 card-hover"
      >
        <div class="text-sm text-gray-900 dark:text-white">{{ item | json }}</div>
      </div>
    </ng-template>
  </div>
</div>
